module.exports = __webpack_public_path__ + "img/joao-silas-water-min.d62bec8c.jpg";